// extracted by mini-css-extract-plugin
module.exports = {"not-found":"MNHs-","notFound":"MNHs-"};